export { DescriptionTooltipWrapper } from './DescriptionTooltipWrapper';
export type { DescriptionTooltipWrapperProps } from './DescriptionTooltipWrapper';
